import { configureStore, combineReducers } from "@reduxjs/toolkit";

import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { encryptTransform } from "redux-persist-transform-encrypt";
import webStoreUserReducer from "../slice/webStoreUserSlice.js";
import storeReducer from "../slice/storeSlice.js";
import sellingCartsReducer from "../slice/sellingCarts.js";
import warehouseReducer from "../slice/warehouseSlice.js";
import MessageReducer from "../slice/MessageSlice.js";
import notificationReducer from "../slice/notificationSlice.js";
import offlineQueueReducer from "../slice/offlineQueue.js";

const reducers = combineReducers({
  webStoreUser: webStoreUserReducer,
  store: storeReducer,
  sellingCart: sellingCartsReducer,
  warehouse: warehouseReducer,
  selectedConversation: MessageReducer,
  notification: notificationReducer,
  offlineQueue: offlineQueueReducer,
});

const persistConfig = {
  key: "root",
  storage,
  transforms: [
    encryptTransform({
      secretKey: process.env.REACT_APP_ENCRYPTION_KEY,
    }),
  ],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export default store;
